import { iaRa } from 'lib/helpers/utility';

export const checkActiveItem = (switchItems, view, location) => {
  const selectedItem = iaRa(switchItems).find((item) => {
    if (view) {
      return item.value === view;
    }

    return item.navigate === location.pathname || null;
  });

  return selectedItem;
};
